export const generatePriceStrings = (t, price, availability, nights) => {
	if (availability != null && price > 0 && (availability === 'paid locally' || availability === 'included')) {
		return (t(`booking_details.${availability}`))
	} else {
		return `${price || 0} € x ${nights.value} ${nights.value == 1 ? t('booking_details.day') : t('booking_details.days')}`
	}
}